export default "__VITE_ASSET__VzJUZjvQ__"